import React from 'react';
import { motion } from 'framer-motion';
import { systemTypes } from '../../../data/questionnaireData';
import './QuestionStep.css';

const SystemTypeStep = ({ selected, onSelect }) => {
  const types = Object.entries(systemTypes);

  return (
    <div className="question-step">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2 className="question-title">What type of solar system do you prefer?</h2>
        <p className="question-subtitle">Choose the option that suits your needs</p>
      </motion.div>

      <div className="system-type-container">
        {types.map(([key, type], index) => (
          <motion.div
            key={key}
            className={`system-type-card ${selected === key ? 'selected' : ''} ${key === 'on-grid' ? 'popular' : ''}`}
            onClick={() => onSelect(key)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + index * 0.1 }}
            whileHover={{ y: -4 }}
          >
            {key === 'on-grid' && (
              <div className="popular-badge">Most Popular</div>
            )}
            <div className="system-type-header">
              <h3 className="system-type-name">{type.name}</h3>
            </div>
            <p className="system-type-description">{type.description}</p>
            <div className="system-benefits">
              <ul className="benefits-list">
                {type.benefits.map((benefit, idx) => (
                  <li key={idx}>{benefit}</li>
                ))}
              </ul>
            </div>
            {selected === key && (
              <motion.div
                className="selected-indicator"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
              >
                Selected
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>

      <motion.div
        className="info-box"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <p>💡 <strong>Not sure?</strong> Most homes benefit from on-grid systems as they're more cost-effective and allow you to sell excess electricity back to the grid.</p>
      </motion.div>
    </div>
  );
};

export default SystemTypeStep;

